import { ReactElement } from 'react';
import PerformableGroupForm, { usePerformableGroup } from '~/components/performable/PerformableGroupForm';
import Sections from '~/components/layout/Sections';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import {
  McmDayToNightInclude,
  McmDroneInclude,
  McmDroneTwilightInclude,
  McmMicrositeInclude,
  McmPhotoInclude,
  McmSocialInclude,
  McmVideoInclude,
} from '~/tenants/mcm/package/common';
import McmPhotoConfig, { McmPhotoType } from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmVideoConfig, { McmVideoOrientation, McmVideoType } from '~/tenants/mcm/performable/video/McmVideoConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';

export default function McmPackageLuxuryForm(): ReactElement {
  const { order, hasPerformable } = usePerformableGroup<McmOrderContext>();

  return (
    <Sections>
      <TenantPackageIncludes>
        <McmPhotoInclude />
        <McmVideoInclude type={McmVideoType.LUXURY} />
        <McmDayToNightInclude />
        <McmDroneInclude type={McmDroneType.VIDEO_PHOTO} />
        <McmDroneTwilightInclude />
        <McmMicrositeInclude />
        <McmSocialInclude />
      </TenantPackageIncludes>
      <PerformableGroupForm performable={McmPhotoConfig}>
        <ZodFieldHidden name="type" value={McmPhotoType.INTERIOR_EXTERIOR} />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmVideoConfig}>
        <ZodFieldHidden name="type" value={McmVideoType.LUXURY} />
        <ZodFieldHidden name="social_edit" value="true" />
        <ZodFieldHidden name="day_to_night" value="true" />
        <ZodFieldHidden name="orientation" value={McmVideoOrientation.HORIZONTAL} />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmDroneConfig} index={2}>
        <ZodFieldHidden name="type" value={McmDroneType.VIDEO_PHOTO} />
      </PerformableGroupForm>
      <PerformableGroupForm performable={McmDroneConfig} index={3}>
        <ZodFieldHidden name="type" value={McmDroneType.PHOTO} />
        <ZodFieldHidden name="twilight" value="true" />
      </PerformableGroupForm>
    </Sections>
  );
}
